import { partnerBase } from "../../../base";
import s from "../partnerPortal.module.css";
import { Panel, SectionTitle } from "./shared";

// The partner API's API-key routes (x-api-key: sk_live_… / sk_test_…).
const ENDPOINTS = [
  ["POST", "/api/v1/sessions", "Create a session · consumes credits"],
  ["GET", "/api/v1/sessions", "List your sessions"],
  ["GET", "/api/v1/sessions/{session_id}", "Session status"],
  ["GET", "/api/v1/results", "List results"],
  ["GET", "/api/v1/results/{id}", "Fetch a result (webhook fallback)"],
  ["GET", "/api/tests", "Test catalogue & credit cost"],
];

export default function Docs() {
  return (
    <div>
      <SectionTitle title="Docs" sub="Quickstart & endpoint reference" />

      <Panel className={s.pg5}>
        <div className={`${s.blockTitle} ${s.pg11}`}>
          Create a test session
        </div>
        <div className={`${s.code} ${s.codeLarge}`}>
          <div>
            <span className={s.codeTeal}>curl</span> -X POST
            {partnerBase}/api/v1/sessions \
          </div>
          <div>
            &nbsp;&nbsp;-H{" "}
            <span className={s.codeAmber}>"x-api-key: sk_live_…"</span> \
          </div>
          <div>
            &nbsp;&nbsp;-H{" "}
            <span className={s.codeAmber}>"Content-Type: application/json"</span> \
          </div>
          <div>
            &nbsp;&nbsp;-d{" "}
            <span className={s.codeAmber}>
              '{"{"} "candidate_email":"a.bello@itm.com", "candidate_name":"Ada Bello", "role":"Frontend Developer" {"}"}'
            </span>
          </div>
          <div className={`${s.codeDim} ${s.pg15}`}>
            // 201 Created
          </div>
          <div className={s.codeDim}>
            {"{"} "success":true, "data":{"{"} "session_id":"sess_8fa21",
            "test_url":"https://…",
          </div>
          <div className={s.codeDim}>
            &nbsp;&nbsp;"credits_charged":3, "is_sandbox":false, "status":"pending" {"}"} {"}"}
          </div>
        </div>
      </Panel>

      <Panel flush>
        {ENDPOINTS?.map((row, i) => (
          <div
            key={row[1]}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 14,
              flexWrap: "wrap",
              padding: "12px 18px",
              borderBottom: i < ENDPOINTS.length - 1 ? "1px solid #141e30" : "none",
            }}
          >
            <span
              className={s.tdMono}
              style={{
                fontSize: 10,
                fontWeight: 800,
                color: row[0] === "POST" ? "#fbbf24" : "#2dd4bf",
                width: 42,
              }}
            >
              {row[0]}
            </span>
            <span className={`${s.tdMono} ${s.pg16}`}>
              {row[1]}
            </span>
            <span className={s.pg17}>{row[2]}</span>
          </div>
        ))}
      </Panel>
    </div>
  );
}
